import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link as RouterLink, useParams } from 'react-router-dom';
import { ActivityOrigin, useActivitySourceStatus } from 'libs.ecoa_shared';
import { Icon, InlineNotification, Link, useLocalizeMessage } from 'libs.nucleus';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ImportTranslationAvailableNotification = ({ activity }) => {
    const t = useLocalizeMessage();
    const { id: activityId } = useParams();
    const { activityOrigin, sourceActivityName, sourceActivityVersion, sourceLink, sourceActivity, isSourceTranslationsAvailable, } = useActivitySourceStatus(activityId);
    const isNewActivity = activityOrigin === ActivityOrigin.ORIGINAL;
    // If no translations are available, don't render the notification.
    if (isNewActivity || !sourceActivity || !isSourceTranslationsAvailable) {
        return null;
    }
    const getSubtitle = () => {
        return t(`The source of this activity, ${sourceActivityName} (v${sourceActivityVersion}), had translations. You can copy those translations to this activity if they are still compatible by clicking the Import translation button.`);
    };
    const getAction = () => {
        return (_jsx(Link, { LinkComponent: RouterLink, to: `${sourceLink}#translation`, target: '_blank', rel: 'noopener noreferrer', children: _jsxs("div", { className: 'flex items-center gap-1', children: [' ', t('Open source activity'), _jsx(Icon, { name: 'externalLink', size: 'sm' })] }) }));
    };
    return (_jsx("div", { className: 'my-8', children: _jsx(InlineNotification, { type: 'info', title: t('Translations available'), subtitle: getSubtitle(), action: getAction() }) }));
};
